import React, { useState, useRef, useEffect } from 'react';
import { CloseOutlined, CheckOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, InputNumber, Row, Switch, Space, message, Modal, Typography, DatePicker, Select } from 'antd';
import {insert, update, getById, getPrimasByRegistroPatronalId, dropPrimaRiesgo} from '../../../../apis/RegistroPatronalApi';
import {conceptos_sat} from '@app/constants/concepto';
import PrimaRiesgo from './Details'
import moment from 'moment';
import _ from 'lodash';

const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const App = ({title, id, clavePatronal ,open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [dataPrimaRiesgos, setDataPrimaRiesgos] = useState([]);
    const [initialValues, setInitialValues] = useState(null);
    const [riesgosSat, setRiesgosSat] = useState([]);
    const [riesgo_sat, setRiesgoSat] = useState(null);
    const [openNewPrimaRiesgo, setOpenNewPrimaRiesgo] = useState(false);
    const [selectedPrimaRiesgo, setSelectedPrimaRiesgo] = useState(null);
    
    
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        let success = false;
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente el concepto!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        if(success){
            finish(true, true);
        }
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await setRiesgosSatFiltered();
                if(ID > 0){
                    await refreshData();
                    await refreshPrimas();
                }else{
                    setInitialValues({
                        nombre: null,
                        descripcion: null,
                        funcion: null,
                        ayuda: null,
                        tipo_dato: null,
                        activo: true
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            if(item.fecha){
                item.fecha = moment(item.fecha, 'YYYY-MM-DD');
            }
            setInitialValues(item);
        }
    }

    const refreshPrimas = async ()=> {
        const response = await getPrimasByRegistroPatronalId(clavePatronal);
        if(response.ok){
          let list = response.payload;
          for (let index = 0; index < list?.length; index++) {
              let detail = list[index];
              if(detail.fecha){
                  detail.fecha = moment(detail.fecha).format('YYYY-MM-DD');
              }
          }
          setDataPrimaRiesgos(list);
        }
      }

    const onClickPrimaRiesgo = ()=>{
        setOpenNewPrimaRiesgo(true);
        setSelectedPrimaRiesgo(null);
    }

    const onClose = (reload)=>{
        finish(reload ?? modified);
        setInitialValues(null);
        setShowModal(false);
    }

    const finishPrimaRiesgo = async () => {
        setOpenNewPrimaRiesgo(false);
        await refreshPrimas();
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const setRiesgosSatFiltered = async ()=>{
        const _riesgosSAT = _.filter(conceptos_sat, (i)=>{
            return i.value == "c_RiesgoPuesto"
        });
        setRiesgosSat(_riesgosSAT[0].enumeration);
    }

    const onChangeRiesgoSat = async (value)=>{
        var _riesgo_sat = _.find(riesgosSat, {value: value});
        setRiesgoSat(_riesgo_sat);
    }

    const columnsPrimasRiesgos = [
        {
          title: 'Fecha',
          dataIndex: 'fecha',
          key: 'fecha',
        },
        {
            title: 'Prima Riesgo',
            dataIndex: 'prima_de_riesgo',
            key: 'prima_de_riesgo',
          },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object)=> {
              return <Space>
                <Button type='primary' size='small' onClick={()=>{
                    setOpenNewPrimaRiesgo(true);
                    setSelectedPrimaRiesgo(object);
                }}>Editar</Button>
                <Button type='primary' size='small' danger onClick={()=>{
                    deleteConfirmPrimaRiesgo(object);
                }}>Eliminar</Button>
              </Space>
            }
        }
    ];

    const deleteConfirmPrimaRiesgo = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la prima de riesgo?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOkPrimaRiesgo(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOkPrimaRiesgo = async (id)=>{
        const response = await dropPrimaRiesgo(id);
        if(response.ok){
            message.success('¡La prima de riesgo ha sido eliminadó!');
            await refreshPrimas();
        }
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span class="" style={{float:'right'}}>
                       
                    </span>
                </div>
                {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                    Guardar
                    </Button>
                </Space>]} />*/}
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        requiredMark
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                        <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="clave_patronal"
                                    label="Clave Patronal"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega la clave patronal" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="nombre"
                                    label="Nombre"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un nombre',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un nombre" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="rfc"
                                    label="RFC"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega el RFC',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega el RFC" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="actividad_economica"
                                    label="Actividad Económica"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega la actividad económica',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega la actividad económica" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="direccion"
                                    label="Dirección"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega la dirección',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una dirección" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="ciudad"
                                    label="Ciudad"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega la dirección',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una dirección" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="estado"
                                    label="Estado"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega el estado',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un estado" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="pais"
                                    label="País"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega el país',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un país" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="cp"
                                    label="CP"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega un código postal',
                                    },
                                    ]}
                                >
                                    <InputNumber placeholder="Por favor agrega un código postal" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="telefono"
                                    label="Teléfono"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega un teléfono',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un teléfono" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="zona_economica"
                                    label="Zona Económica"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona una zona económica',
                                    },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona una zona económica">
                                        <Option value={'A'}>A</Option>
                                        <Option value={'B'}>B</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="delegacion_imss"
                                    label="Delegación IMSS"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega una delegación',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una delegación" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="subdelegacion_imss"
                                    label="Subdelegación IMSS"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega una subdelegación',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega una subdelegación" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="pct_reversion"
                                    label="PCT Reversion"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un valor" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="guia_imss"
                                    label="Guia IMSS"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un valor" />
                                </Form.Item>
                            </Col>
                            {
                                riesgosSat && riesgosSat.length > 0 && 
                                <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                    <Form.Item
                                        name="clase_riesgo"
                                        label="Clase de Riesgo"
                                        rules={[
                                        {
                                            required: true,
                                            message: 'Por favor agrega un valor',
                                        },
                                        ]}
                                    >
                                        <Select placeholder="Por favor selecciona una clase de riesgo" 
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            onChange={onChangeRiesgoSat}>
                                            <Option value={''}>Ninguno</Option>
                                            {
                                                riesgosSat.map((item)=><Option value={item.value}>{item.text}</Option>)
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            }
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="convenio_rembolso"
                                    label="Convenio de Rembolso"
                                    rules={[
                                    {
                                        required: false,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="afiliacion_anio"
                                    label="Afiliación Año"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un valor" />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="afiliacion_mes"
                                    label="Afiliación Mes"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un valor',
                                    },
                                    ]}
                                >
                                    <Input placeholder="Por favor agrega un valor" />
                                </Form.Item>
                            </Col>
                            {/* <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="fecha"
                                    label="Fecha"
                                >
                                    <DatePicker placeholder="DD/MM/YYYY"  style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                                </Form.Item>
                            </Col> */}
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                </Form>
            }
             <Divider></Divider>
            <div style={{height: 60}}>
                <div style={{float: 'left'}}>
                    <Title level={2}>Primas de Riesgo de Trabajo</Title>
                </div>
                <span class="" style={{float:'right'}}>
                    <Space>
                        <Button disabled={!ID} onClick={onClickPrimaRiesgo} type="primary" style={{marginBottom: 10}}>Agregar prima de riesgo</Button>
                    </Space>
                </span>
            </div>
            {
                openNewPrimaRiesgo && 
                <div style={{marginBottom: 10}}>
                    {
                        !selectedPrimaRiesgo &&
                        <PrimaRiesgo title="Agregar prima" registroPatronalId={ID} primaRiesgo={selectedPrimaRiesgo} finish={finishPrimaRiesgo} open={openNewPrimaRiesgo}/>
                    }
                    {
                        selectedPrimaRiesgo &&
                        <PrimaRiesgo title="Editar prima" registroPatronalId={ID} definicion={selectedPrimaRiesgo} id={selectedPrimaRiesgo.id} finish={finishPrimaRiesgo} open={openNewPrimaRiesgo}/>
                    }
                </div>
            }
            {
                dataPrimaRiesgos.length === 0 ? <Empty />:
                <Table dataSource={dataPrimaRiesgos} columns={columnsPrimasRiesgos} />
            }
            </>
        </Drawer>
    );
};
export default App;